import styles from '../SearchModal.module.scss'

type SearchFilterChipProps = {
  active: boolean
  disabled: boolean
  label: string
  onClick: () => void
}

export function SearchFilterChip({ active, disabled, label, onClick }: SearchFilterChipProps) {
  return (
    <button
      aria-pressed={active}
      className={styles.filterChip}
      data-state={active ? 'active' : 'inactive'}
      disabled={disabled}
      type="button"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
